import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { environment } from '../../../../environments/environment';
import { FormsServiceService } from '../../../api/services/forms-service.service';
import { ModalRendererComponent } from '../../widgets/modal-renderer/modal-renderer.component';

@Component({
    selector: 'app-config-with-button',
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
    ],
    templateUrl: './config-with-button.component.html',
    styleUrl: './config-with-button.component.css'
})
export class ConfigWithButtonComponent {
  @Input() formGroup!: FormGroup;
  @Input() fields: any;
  @Input() activeModalContext: any;
  @Input() formData: any;
  @Output() buttonClick = new EventEmitter<void>();
  endpoint = environment.api_endpoint;

  constructor(private formService: FormsServiceService) {}
  resolvePlaceholders(text: string): string {
    if (!text) return text;

    const placeholderRegex = /{{(.*?)}}/g;

    return text.replace(placeholderRegex, (_match, key) => {
      key = key.trim();

      // 1. direct component property
      if ((this as any)[key] !== undefined) {
        return (this as any)[key];
      }
      // 2. modal context
      if (
        this.activeModalContext &&
        this.activeModalContext[key] !== undefined
      ) {
        return this.activeModalContext[key];
      }

      return _match; // fallback
    });
  }

  handleButtonClick(field: any) {
    const action = field?.properties?.buttonProperty?.clickAction;

    switch (action) {
      case 'modalOpen':
        this.openModal(field);
        break;

      case 'apiIntegration':
      case 'footerFieldApiIntegration':
        this.callApiIntegration(field);
        break;

      default:
        console.warn('Unknown clickAction:', action);
    }
  }

  openModal(field: any) {
    const modalId = `open_modal_${field.fieldName}`;
    const modal = document.getElementById(modalId);
    if (modal) modal.classList.add('show');
  }

  callApiIntegration(field: any) {
    const btn = {
      ...field.properties?.buttonProperty,
      clickAction: field.properties?.buttonProperty?.clickAction,
      fieldName: field.fieldName,
      field,
    };

    const action = btn.clickAction;

    // ✅ Handle API directly
    // if (action === 'footerFieldApiIntegration') {
    //   this.triggerApi(field);
    // }

    // ✅ Still emit for global handling (optional but recommended)
    this.buttonClick.emit(action);
  }

  async triggerApi(field: any) {
    try {
      const api = this.formData?.apiIntegration;

      if (!api?.useAPI) return;

      // ✅ Step 1: Prepare endpoint
      const api_endpoint = this.endpoint;

      let url = api?.apiUrl ? api.apiUrl : '';

      const replacements = {
        api_endpoint: api_endpoint,
      };

      // ✅ Replace {{api_endpoint}}
      url = this.formService.replaceTemplateTokens(url, replacements);

      // ✅ Method
      const method = api?.apiMethod || 'POST';

      // ✅ Headers (optional safe handling)
      const headers = {
        'Content-Type': 'application/json',
        ...(api.apiHeaders || {}),
      };

      // ✅ Body
      const body = {
        ...api.apiRequestBody,
        formId: this.formData?.formCollection?.formId,
        data: this.formData,
      };

      // 🚀 API Call
      const response = await fetch(url, {
        method,
        headers,
        body: JSON.stringify(body),
      });

      const result = await response.json();

      if (response.ok) {
        console.log(api.apiSuccessMessage);
      } else {
        console.error(api.apiErrorMessage || 'API failed');
      }
    } catch (err) {
      console.error('API Error:', err);
    }
  }

  closeOnBackdropClick(event: MouseEvent, modalID: any) {
    const modal = document.getElementById(modalID);
    if (event.target === modal) {
      this.closeModal(modalID);
    }
  }

  closeModal(modalID: any) {
    const modal = document.getElementById(modalID);
    if (modal) modal.classList.remove('show');
    this.activeModalContext = null;
  }
}
